module.exports = __webpack_public_path__ + "media/images/athletes/3323-d79d38896e22ca6cd37a2b283793cad4.png";